import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective } from '@ngx-translate/core';
import { AutofocusDirective } from '../autofocus/autofocus.directive';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  imports: [TranslateDirective, AutofocusDirective],
})
export class YesNoDialogComponent {
  public readonly modal = inject(NgbActiveModal);

  @Input()
  public title!: string;

  @Input()
  public text!: string;
}
